import * as React from "react"

const SvgParagraphIndentFirstLine = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 21.286a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712q0-.425.288-.713A.97.97 0 0 1 4 19.286h16a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm8-4a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h8a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm0-4a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h8a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm0-4a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h8a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm-8-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 4.286q0-.425.288-.713A.97.97 0 0 1 4 3.286h16a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm-.15 10.15q-.25.25-.55.125-.3-.126-.3-.475v-5.6q0-.35.3-.475.3-.126.55.125l2.8 2.8a.48.48 0 0 1 0 .7z" />
  </svg>
)
export default SvgParagraphIndentFirstLine
